import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  QueryList,
  TrackByFunction,
  ViewChildren,
} from '@angular/core';
import { LogService } from '@shared/services';
import { Logger } from '@unleash-tech/js-logger';
import { Tooltip } from 'primeng/tooltip';
import { BehaviorSubject } from 'rxjs';
import { IActionItem } from 'src/app/bar/models/action-item.model';

export interface ActionComponent {
  data: any;
}

@Component({
  selector: 'home-actions',
  templateUrl: './actions.component.html',
  styleUrls: ['./actions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActionsComponent {
  @Input() items: IActionItem[];

  @Input() selected: boolean;

  //Output the event id
  @Output() onAction = new EventEmitter<string>();

  @ViewChildren(Tooltip) tooltipsComps: QueryList<Tooltip>;

  showShortcut$ = new BehaviorSubject<boolean>(false);

  get isShowingShortcut() {
    return this.showShortcut$.getValue();
  }

  restoreTimeout: any;

  private logger: Logger;

  constructor(private ref: ElementRef, private logService: LogService) {
    this.logger = logService.scope('HomeActionsComponent');

    this.showShortcut$.subscribe((s) => {
      this.shouldShowKeysTooltips(s);
    });
  }

  // @HostListener('window:keydown', ['$event']) onKeyDown(event: KeyboardEvent) {
  //   if (getModifierKey(event) === 'Control' && this.selected && this.showShortcut$.getValue() === false) {
  //     this.showShortcut$.next(true);
  //   }
  // }

  // @HostListener('window:keyup', ['$event']) onKeyUp(event: KeyboardEvent) {
  //   if (getModifierKey(event) === 'Control' && this.selected && this.showShortcut$.getValue() === true) {
  //     this.showShortcut$.next(false);
  //   }
  // }

  /** @description call trough a parent component to show tooltips with keybinding for actions */
  shouldShowKeysTooltips(show: boolean) {
    if (!this.tooltipsComps) return;

    this.tooltipsComps['_results'].map((t, i) => {
      show ? t.show() : t.hide();
    });
  }

  trackItems: TrackByFunction<IActionItem> = (index: number, item: IActionItem) => item?.id;
}
